var _mask, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 32,
    viewBox: "0 0 32 32",
    width: 32,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "a",
    height: 32,
    maskUnits: "userSpaceOnUse",
    width: 32,
    x: 0,
    y: 0
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#eceded",
    height: 32,
    rx: 16,
    width: 32
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)",
    stroke: "#000",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    height: 30,
    rx: 15,
    width: 30,
    x: 1,
    y: 1
  }), /*#__PURE__*/React.createElement("rect", {
    height: 9.63636,
    rx: 4.81818,
    width: 9.63636,
    x: 11.1794,
    y: 7.72803
  }), /*#__PURE__*/React.createElement("rect", {
    height: 18.3636,
    rx: 9.18182,
    width: 18.3636,
    x: 6.82007,
    y: 21.5483
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.4ecd631fdc30df08574c5607eca1e2f1.svg";
export { ForwardRef as ReactComponent };